import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-income-summary',
  templateUrl: './income-summary.component.html',
  styleUrls: ['./income-summary.component.scss']
})
export class IncomeSummaryComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
